import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { ISimulatorApplication } from "types/simulatorApplicationTypes"

interface SimulatorApplicationState {
  simulatorApplications: Array<ISimulatorApplication>
  currentSimulatorApplication: ISimulatorApplication | undefined
}

const initialState: SimulatorApplicationState = {
  simulatorApplications: [] as ISimulatorApplication[],
  currentSimulatorApplication: undefined,
}

export const simulatorApplicationSlice = createSlice({
  name: "simulators",
  initialState,
  reducers: {
    setSimulatorApplications: (state, action: PayloadAction<Array<ISimulatorApplication>>) => {
      state.simulatorApplications = action.payload
    },
    setCurrentSimulatorApplication: (state, action: PayloadAction<ISimulatorApplication>) => {
      state.currentSimulatorApplication = action.payload
    },
    addSimulatorApplication: (state, action: PayloadAction<ISimulatorApplication>) => {
      state.simulatorApplications?.push(action.payload)
    },
    updateSimulatorApplication: (state, action: PayloadAction<ISimulatorApplication>) => {
      var index = state.simulatorApplications.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.simulatorApplications[index] = action.payload
      }
    },
    removeSimulatorApplication: (state, action: PayloadAction<ISimulatorApplication>) => {
      var index = state.simulatorApplications.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.simulatorApplications.splice(index, 1)
      }
    },
    resetSimulatorApplication: (state, _action) => {
      state.simulatorApplications = []
      state.currentSimulatorApplication = undefined
    },
  },
})

export const {
  setSimulatorApplications,
  addSimulatorApplication,
  updateSimulatorApplication,
  removeSimulatorApplication,
  setCurrentSimulatorApplication,
  resetSimulatorApplication,
} = simulatorApplicationSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.simulatorapplication

export default simulatorApplicationSlice.reducer
